import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@app/env';
import { CurrentUser, Employee } from '@app/shared/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  readonly #http = inject(HttpClient);
  readonly USERS_API_BASE_URL = `${environment.apiBaseUrl}/users`;

  getCurrentUser(): Observable<CurrentUser> {
    return this.#http.get<CurrentUser>(`${this.USERS_API_BASE_URL}/current-user`);
  }

  getUserProfile(userId: string): Observable<Employee> {
    return this.#http.get<Employee>(`${this.USERS_API_BASE_URL}/${userId}/profile`);
  }

  updateUser(employeeId: string, employeeData: Employee) {
    return this.#http.put<Employee>(
      `${this.USERS_API_BASE_URL}/${employeeId}/profile`,
      employeeData,
    );
  }

  deleteUserAccount() {
    return this.#http.delete<void>(`${this.USERS_API_BASE_URL}/me`);
  }

  setPassword(password: string) {
    return this.#http.put<void>(`${this.USERS_API_BASE_URL}/password`, {
      password,
    });
  }
}
